/* Try It In Real Life — v14 2026-08-17 LIVE MODE per Yaniv: ?proof=1 gate REMOVED. Block shows on RING product types only (allowlist below, all store spelling variants; 'Ring sizer' excluded). Kill switch: add ?proof=0 to any URL to hide for that browser tab-session; delete the include line in snippets/layout-get-includes-end.liquid to remove entirely. */
/* v16 2026-09-22 per Yaniv: the replica cart line also carries HIDDEN properties so the admin order shows what the client picked on the ring page:
   _Center Stone = the ct/mm option of the ring variant selected when "Get My Replica" is pressed (e.g. "1ct / 6.5mm"); omitted for designs with no ct/mm option (plain bands).
   _Ring variant = that variant's full title (e.g. "14K Yellow Gold / Natural Diamonds / 1ct / 6.5mm").
   Underscore = not shown to the customer in cart/checkout; shown on the order in Shopify admin. Lookup failure never blocks the add. */
(function(){
  'use strict';
  var PROOF_HANDLE='try-it-in-real-life-preview';
  var GREY='grayscale(1) brightness(.82) contrast(.72) sepia(.08)';
  var RING_TYPES=['anniversary ring','bridal set','diamond letter ring','engagement ring','fashion ring','initial ring','man wedding band','wedding band','wedding ring'];

  /* ---------- CART PAGE + DRAWER: per-design image ---------- */
  function cartImages(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var proofItems=(cart.items||[]).filter(function(it){return it.handle===PROOF_HANDLE;});
      if(!proofItems.length)return;
      var containers=[].slice.call(document.querySelectorAll('.cart-page__item, .product-cart'))
        .filter(function(c){return c.querySelector('a[href*="'+PROOF_HANDLE+'"]')&&!c.querySelector('.claude-proof-img');});
      containers.forEach(function(row,idx){
        var it=proofItems[Math.min(idx,proofItems.length-1)];
        var dh=it&&it.properties&&it.properties._design_handle;
        if(!dh)return;
        fetch('/products/'+dh+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
          if(!p||!p.featured_image)return;
          var src=p.featured_image;if(src.indexOf('//')===0)src='https:'+src;
          var img=row.querySelector('img');
          if(img){
            img.src=src;
            ['srcset','data-srcset','data-src','data-original','loading'].forEach(function(a){img.removeAttribute(a);});
            img.classList.remove('lazyload','lazyloaded');img.classList.add('claude-proof-img');
            img.style.filter=GREY;img.style.objectFit='cover';
          }else{
            var host=row.querySelector('[class*="col-"]')||row.firstElementChild;
            if(!host)return;
            var wrap=document.createElement('div');
            wrap.className='claude-proof-img';
            wrap.style.cssText='flex:0 0 auto;width:110px;margin-right:15px;align-self:center';
            wrap.innerHTML='<img src="'+src+'" alt="Replica preview" style="width:100%;display:block;filter:'+GREY+';object-fit:cover">';
            host.insertBefore(wrap,host.firstChild);
          }
        }).catch(function(){});
      });
    }).catch(function(){});
  }
  if(location.pathname==='/cart'||location.pathname.indexOf('/cart?')===0){
    var runs=0;var loop=function(){runs++;cartImages();if(runs<4)setTimeout(loop,1200);};
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(loop,300);});}else{setTimeout(loop,300);}
    return;
  }
  setInterval(function(){if(document.querySelector('.product-cart a[href*="'+PROOF_HANDLE+'"]'))cartImages();},2500);

  /* ---------- PRODUCT PAGE: LIVE for ring types (kill switch ?proof=0) ---------- */
  try{
    var qs=new URLSearchParams(location.search);
    if(qs.get('proof')==='0')sessionStorage.setItem('claudeProofOff','1');
    if(qs.get('proof')==='1')sessionStorage.removeItem('claudeProofOff');
    if(sessionStorage.getItem('claudeProofOff')==='1')return;
  }catch(e){}
  if(!location.pathname.includes('/products/'))return;
  if(location.pathname.includes(PROOF_HANDLE))return;

  var designHandle=location.pathname.split('/products/')[1].split('/')[0].split('?')[0];

  function getProductType(cb){
    try{
      var t=window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product&&window.ShopifyAnalytics.meta.product.type;
      if(t){cb(t);return;}
    }catch(e){}
    fetch('/products/'+designHandle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){cb(p&&p.type||'');}).catch(function(){cb('');});
  }
  function isRing(t){
    var n=String(t||'').toLowerCase().replace(/-/g,' ').replace(/\s+/g,' ').trim();
    return RING_TYPES.indexOf(n)!==-1;
  }

  /* Ring variant the client has selected right now: the product form's id field, then ?variant=. */
  function selectedVariantId(atc){
    var f=atc&&atc.form;
    var el=(f&&f.querySelector('[name="id"]'))||document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id=el&&el.value;
    if(!id){try{id=new URLSearchParams(location.search).get('variant');}catch(e){}}
    return id?String(id):'';
  }
  var STONE_RE=/\d\s*ct\b|\d\s*mm\b/i;
  /* Resolves {stone, variant} for the selected ring variant; resolves {} on any failure (never rejects). */
  function ringChoice(atc){
    var id=selectedVariantId(atc);
    if(!id)return Promise.resolve({});
    return fetch('/products/'+designHandle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
      var v=p&&(p.variants||[]).filter(function(x){return String(x.id)===id;})[0];
      if(!v)return {};
      var vals=[v.option1,v.option2,v.option3].filter(function(o){return o&&STONE_RE.test(o);});
      return {stone:vals[0]||'',variant:v.title||''};
    }).catch(function(){return {};});
  }

  function init(){
    if(document.getElementById('claude-proof-block'))return;
    var atcs=[].slice.call(document.querySelectorAll('.js-product-button-add-to-cart'));
    var atc=atcs.filter(function(b){return b.offsetWidth>100;})[0]||atcs[0];
    if(!atc){setTimeout(init,500);return;}
    getProductType(function(ptype){
      if(!isRing(ptype))return;
      build(atc);
    });
  }

  function build(atc){
    if(document.getElementById('claude-proof-block'))return;
    var INK='#354e57',GOLD='#a8874f';
    var css=''+
    '#claude-proof-block,#claude-proof-block *,#claude-proof-ovl .cp-modal,#claude-proof-ovl .cp-modal *{font-family:inherit}'+
    '#claude-proof-block{margin:14px 0 6px;border:1px solid rgba(53,78,87,.28);border-left:3px solid '+GOLD+';background:#f8f6f1;padding:14px 18px;color:'+INK+'}'+
    '#claude-proof-block .cp-flex{display:flex;align-items:center;justify-content:space-between;gap:18px;flex-wrap:wrap}'+
    '#claude-proof-block .cp-left{flex:1 1 300px;min-width:260px}'+
    '#claude-proof-block .cp-tag{font-size:11px;letter-spacing:2.2px;text-transform:uppercase;color:'+GOLD+';font-weight:600}'+
    '#claude-proof-block p{font-size:14px;line-height:1.45;margin:5px 0 0;color:#41535b}'+
    '#claude-proof-block p.cp-price-line{font-size:15px;margin:4px 0 0;color:'+INK+'}'+
    '#claude-proof-block p.cp-price-line b{font-size:17px;font-weight:700}'+
    '#claude-proof-block .cp-micro{font-size:11.5px;color:#5a6c74;margin-top:5px;display:block}'+
    '#claude-proof-block .cp-cta{background:#fff;border:1px solid '+INK+';color:'+INK+';padding:0 22px;min-height:46px;font-size:13px;letter-spacing:.65px;text-transform:uppercase;cursor:pointer;transition:background .2s,color .2s;flex:0 0 auto}'+
    '#claude-proof-block .cp-cta:hover{background:'+INK+';color:#fff}'+
    '#claude-proof-block .cp-cta:focus-visible{outline:2px solid '+GOLD+';outline-offset:2px}'+
    '#claude-proof-ovl{position:fixed;inset:0;background:rgba(23,34,39,.62);display:none;align-items:center;justify-content:center;z-index:99999;padding:16px}'+
    '#claude-proof-ovl.open{display:flex}'+
    '#claude-proof-ovl .cp-modal{background:#fff;max-width:720px;width:100%;max-height:92vh;overflow:auto;padding:38px 42px 30px;position:relative;color:'+INK+';font-size:15px}'+
    '@media(max-width:760px){#claude-proof-ovl .cp-modal{padding:24px 20px}}'+
    '#claude-proof-ovl .cp-x{position:absolute;top:12px;right:16px;background:none;border:none;font-size:26px;color:#8a969b;cursor:pointer;min-width:44px;min-height:44px}'+
    '#claude-proof-ovl .cp-mtag{font-size:12px;letter-spacing:2.2px;text-transform:uppercase;color:'+GOLD+';font-weight:600}'+
    '#claude-proof-ovl h2{font-size:26px;font-weight:400;margin:10px 0 0;line-height:1.3;color:'+INK+';text-transform:none}'+
    '#claude-proof-ovl .cp-design{margin-top:18px;background:#f8f6f1;border:1px solid rgba(53,78,87,.18);padding:14px 16px;display:flex;gap:14px;align-items:center}'+
    '#claude-proof-ovl .cp-design img{width:64px;height:64px;object-fit:cover;filter:'+GREY+'}'+
    '#claude-proof-ovl .cp-dn{font-size:15.5px;font-weight:600}'+
    '#claude-proof-ovl .cp-lab{margin-top:20px;font-size:12px;letter-spacing:1.8px;text-transform:uppercase;color:#5a6c74}'+
    '#claude-proof-ovl .cp-sizes{display:grid;grid-template-columns:repeat(10,1fr);gap:7px;margin-top:9px}'+
    '@media(max-width:760px){#claude-proof-ovl .cp-sizes{grid-template-columns:repeat(5,1fr)}}'+
    '#claude-proof-ovl .cp-sz{border:1px solid rgba(53,78,87,.3);background:#fff;min-height:44px;font-size:14.5px;cursor:pointer;text-align:center;color:'+INK+';transition:border-color .15s}'+
    '#claude-proof-ovl .cp-sz:hover{border-color:'+INK+'}'+
    '#claude-proof-ovl .cp-sz:focus-visible{outline:2px solid '+GOLD+';outline-offset:1px}'+
    '#claude-proof-ovl .cp-sz.sel{background:'+INK+';color:#fff;border-color:'+INK+'}'+
    '#claude-proof-ovl .cp-price{margin-top:20px;display:flex;align-items:baseline;gap:14px;flex-wrap:wrap}'+
    '#claude-proof-ovl .cp-p{font-size:28px;color:#0b0b0b}'+
    '#claude-proof-ovl .cp-cr{font-size:13px;color:'+GOLD+';font-weight:600;letter-spacing:1px;text-transform:uppercase}'+
    '#claude-proof-ovl .cp-eff{width:100%;font-size:14px;color:#5a6c74}'+
    '#claude-proof-ovl .cp-go{margin-top:16px;width:100%;background:'+INK+';color:#fff;border:1px solid '+INK+';min-height:56px;font-size:14px;letter-spacing:.65px;text-transform:uppercase;cursor:pointer;transition:background .2s}'+
    '#claude-proof-ovl .cp-go:disabled{background:#aeb9bd;border-color:#aeb9bd;cursor:not-allowed}'+
    '#claude-proof-ovl .cp-err{display:none;margin-top:10px;font-size:13.5px;color:#c0392b}'+
    '#claude-proof-ovl .cp-ass{margin-top:14px;font-size:14px;color:#5a6c74;line-height:1.8}'+
    '#claude-proof-ovl .cp-ass b{color:'+INK+';font-weight:600}'+
    '#claude-proof-ovl details{border-bottom:1px solid rgba(53,78,87,.15)}'+
    '#claude-proof-ovl details:first-of-type{border-top:1px solid rgba(53,78,87,.15);margin-top:18px}'+
    '#claude-proof-ovl summary{font-size:14.5px;padding:12px 2px;cursor:pointer;list-style:none;display:flex;justify-content:space-between}'+
    '#claude-proof-ovl summary:after{content:"+";color:#8a969b}'+
    '#claude-proof-ovl details[open] summary:after{content:"–"}'+
    '#claude-proof-ovl .cp-a{font-size:13.5px;color:#5a6c74;padding:0 2px 13px;line-height:1.55}'+
    '@media(prefers-reduced-motion:reduce){#claude-proof-block *,#claude-proof-ovl *{transition:none!important}}';
    var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

    var ogImg=(document.querySelector('meta[property="og:image"]')||{}).content||'';
    var h1=document.querySelector('h1');
    var title=h1?h1.textContent.replace(/\s+/g,' ').trim():'This design';

    var anchor=atc.closest('.d-flex');
    if(!anchor||anchor.contains(document.querySelector('.product-page__price'))){
      anchor=atc.parentElement&&(atc.parentElement.offsetWidth-atc.offsetWidth)>40?atc.parentElement:atc;
    }

    var block=document.createElement('div');block.id='claude-proof-block';
    block.innerHTML='<div class="cp-flex">'+
      '<div class="cp-left"><div class="cp-tag">Try It In Real Life</div>'+
      '<p>An exact replica of this ring, printed in your size — try it on at home before you order the real one.</p>'+
      '<p class="cp-price-line"><b>$199</b> — fully credited toward your ring.</p>'+
      '<span class="cp-micro">Yours to keep · Credit never expires</span></div>'+
      '<button type="button" class="cp-cta" id="cp-open">Try It First — $199</button>'+
      '</div>';
    anchor.insertAdjacentElement('afterend',block);

    var sizes='';for(var s=4;s<=13;s+=0.5){sizes+='<button type="button" class="cp-sz">'+(s%1?s.toFixed(1):s)+'</button>';}
    var ovl=document.createElement('div');ovl.id='claude-proof-ovl';ovl.setAttribute('role','dialog');ovl.setAttribute('aria-modal','true');ovl.setAttribute('aria-labelledby','cp-title');
    ovl.innerHTML='<div class="cp-modal">'+
      '<button type="button" class="cp-x" aria-label="Close dialog">×</button>'+
      '<div class="cp-mtag">Try It In Real Life · Printed for you</div>'+
      '<h2 id="cp-title">Try this ring on your own hand before you decide.</h2>'+
      '<div class="cp-design">'+(ogImg?'<img src="'+ogImg+'" alt="Replica preview of '+title.replace(/"/g,'&quot;')+'">':'')+'<div><div class="cp-dn">'+title+' Replica</div></div></div>'+
      '<div class="cp-lab" id="cp-size-label">Select finger size</div>'+
      '<div class="cp-sizes" role="group" aria-labelledby="cp-size-label">'+sizes+'</div>'+
      '<div class="cp-price"><span class="cp-p">$199</span><span class="cp-cr">100% credited toward your ring</span><span class="cp-eff">The full $199 is credited back on your next order of a real ring.</span></div>'+
      '<button type="button" class="cp-go" disabled>Select a size above</button>'+
      '<div class="cp-err" role="alert"></div>'+
      '<div class="cp-ass">✓ <b>Yours to keep</b> — nothing to return<br>✓ <b>Credit never expires</b>, works on any piece<br>✓ <b>Free shipping</b> + free ring sizer</div>'+
      '<details><summary>What exactly will I receive?</summary><div class="cp-a">An exact replica of this ring, 3D-printed to order in your size. It shows the true size and shape, and how the design sits on your finger. It is plastic — not metal, and it holds no gemstones.</div></details>'+
      '<details><summary>What if I never buy the ring?</summary><div class="cp-a">Keep the replica. Your $199 credit never expires and can be used on any Segal piece.</div></details>'+
      '<details><summary>When do I get the $199 back?</summary><div class="cp-a">The day your replica is delivered, your personal $199 credit code is emailed to you. Use it on your next order of a real ring — it applies automatically at checkout.</div></details>'+
      '</div>';
    document.body.appendChild(ovl);

    var lastFocus=null;
    function openM(){lastFocus=document.activeElement;ovl.classList.add('open');setTimeout(function(){ovl.querySelector('.cp-x').focus();},30);}
    function closeM(){ovl.classList.remove('open');if(lastFocus&&lastFocus.focus)lastFocus.focus();}
    document.getElementById('cp-open').addEventListener('click',openM);
    ovl.querySelector('.cp-x').addEventListener('click',closeM);
    ovl.addEventListener('click',function(e){if(e.target===ovl)closeM();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&ovl.classList.contains('open'))closeM();});
    var size=null;
    ovl.querySelectorAll('.cp-sz').forEach(function(b){b.addEventListener('click',function(){
      ovl.querySelectorAll('.cp-sz').forEach(function(x){x.classList.remove('sel');});b.classList.add('sel');size=b.textContent;
      var g=ovl.querySelector('.cp-go');g.disabled=false;g.textContent='Get My Replica — $199';});});

    ovl.querySelector('.cp-go').addEventListener('click',function(){
      if(!size)return;
      var btn=this,err=ovl.querySelector('.cp-err');
      btn.disabled=true;btn.textContent='Adding…';err.style.display='none';
      Promise.all([
        fetch('/products/'+PROOF_HANDLE+'.js').then(function(r){if(!r.ok)throw new Error('product lookup '+r.status);return r.json();}),
        ringChoice(atc)
      ])
      .then(function(res){
        var p=res[0],ring=res[1]||{};
        var v=(p.variants||[]).filter(function(x){return String(x.option1)===String(size)||String(x.title)===String(size);})[0];
        if(!v)throw new Error('size '+size+' not found');
        var props={'Design':title,'Ring Size':size,'_design_handle':designHandle};
        if(ogImg)props['_design_image']=ogImg;
        if(ring.stone)props['_Center Stone']=ring.stone;
        if(ring.variant)props['_Ring variant']=ring.variant;
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1,properties:props})})
          .then(function(r){if(!r.ok)throw new Error('cart add '+r.status);return r.json();});
      })
      .then(function(){btn.textContent='Added — opening your cart…';window.location.href='/cart';})
      .catch(function(e){btn.disabled=false;btn.textContent='Get My Replica — $199';err.textContent='Could not add the replica ('+e.message+'). Try again.';err.style.display='block';});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
